import { useState, useEffect } from 'react';
import axios from 'axios';

const apiUrl = "https://elcobradorleague.com/api";

export const usePlayerMatches = (playerId, idleague) => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!idleague) {
      setMatches([]);
      setLoading(false);
      return;
    }

    const controller = new AbortController();

    const fetchMatches = async () => {
      try {
        setLoading(true);
        setError(null);

        let url = `${apiUrl}/api.php?endpoint=matches&idleague=${idleague}`;
        if (playerId && playerId !== 0) {
          url += `&playerId=${playerId}`;
        }

        const res = await axios.get(url, {
          headers: {
          'X-API-TOKEN': process.env.REACT_APP_API_TOKEN
        },
          signal: controller.signal
        });

        setMatches(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        if (err.name !== 'CanceledError') {
          setError(err);
          setMatches([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
    return () => controller.abort();
  }, [playerId, idleague]);

  return { matches, loading, error };
};
